module.exports = __webpack_public_path__ + "img/icon-setting-gray.5db13bf1.png";